"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
function cardIdsMatch(a, b) {
  if (a == null || b == null) {
    return false;
  }
  return String(a) === String(b);
}
var CardNoteWrapper = function CardNoteWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "showEdit", _descriptor, _this);
      _initializerDefineProperty(_this, "savingNote", _descriptor2, _this);
      _this.loadCard = function () {
        _state.AppUI.cardStore.getShow({
          ids: {
            cardId: _this.cardId
          }
        });
      };
      _this.onSubmitNote = function (note) {
        var _this$card;
        if (!((_this$card = _this.card) !== null && _this$card !== void 0 && _this$card.id) || typeof _this.card.set !== 'function') {
          return;
        }
        _this.savingNote = true;
        _this.card.set('note', note);
        _this.updateReviewIndexNote(note);
        _state.DeckUI.cardStore.update({
          ids: {
            cardId: _this.card.id
          },
          data: {
            note: note
          }
        }, _this.afterSubmitNote);
      };
      _this.onChangeShowNoteBeforeReveal = function () {
        var _this$card2;
        if (!((_this$card2 = _this.card) !== null && _this$card2 !== void 0 && _this$card2.id) || typeof _this.card.set !== 'function') {
          return;
        }
        _this.card.set('showNoteBeforeReveal', !_this.card.showNoteBeforeReveal);
        _state.DeckUI.cardStore.update({
          ids: {
            cardId: _this.card.id
          },
          data: {
            showNoteBeforeReveal: _this.card.showNoteBeforeReveal
          }
        }, _this.afterSubmitNote);
      };
      _this.afterSubmitNote = function () {
        _this.savingNote = false;
        _this.showEdit = false;
      };
      _this.onSetShowEdit = function (showEdit) {
        _this.showEdit = showEdit;
      };
      _this.frontText = function () {
        var card = _this.card;
        if (!card) return '';
        if (typeof card.reviewFrontText === 'function') {
          return card.reviewFrontText(50);
        }
        var text;
        if (card.userSubmission && card.cardTypeSlug === 'user_submission') {
          text = card.frontText;
        }
        if (!(card.userSubmission && card.cardTypeSlug === 'user_submission') && card.word && !card.sentence) {
          text = card.word.targetTextWithDefiniteArticle;
        }
        if (!card.userSubmission && card.sentence) {
          text = (0, _utils.displayTargetTextCorrectedForLanguage)(card.sentence.targetText, card.languageId);
        }
        if (text && text.length > 50) {
          return "".concat(text.substring(0, 50), "...");
        }
        return text;
      };
      _this.updateReviewIndexNote = function (note) {
        var _AppUI$cardStore$show;
        var updateIndexData = function updateIndexData(store) {
          var _store$indexData;
          var indexCard = store === null || store === void 0 || (_store$indexData = store.indexData) === null || _store$indexData === void 0 ? void 0 : _store$indexData.find(function (item) {
            return cardIdsMatch(item.id, _this.card.id);
          });
          if (!indexCard) {
            return;
          }
          if (typeof indexCard.set === 'function') {
            indexCard.set('note', note);
          } else {
            indexCard.note = note;
          }
        };
        updateIndexData(_state.AppUI.cardStore);
        updateIndexData(_state.DeckUI.cardStore);
        if (cardIdsMatch((_AppUI$cardStore$show = _state.AppUI.cardStore.showData) === null || _AppUI$cardStore$show === void 0 ? void 0 : _AppUI$cardStore$show.id, _this.card.id) && typeof _state.AppUI.cardStore.showData.set === 'function') {
          _state.AppUI.cardStore.showData.set('note', note);
        }
      };
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.cardId && (!_state.DeckUI.currentCard || !cardIdsMatch(_state.DeckUI.currentCard.id, this.cardId))) {
          this.loadCard();
        }
      }
    }, {
      key: "cardId",
      get: function get() {
        var _this$props$route, _this$props$card, _DeckUI$currentCard;
        if ((_this$props$route = this.props.route) !== null && _this$props$route !== void 0 && (_this$props$route = _this$props$route.params) !== null && _this$props$route !== void 0 && _this$props$route.cardId) {
          return this.props.route.params.cardId;
        }
        if ((_this$props$card = this.props.card) !== null && _this$props$card !== void 0 && _this$props$card.id) {
          return this.props.card.id;
        }
        if (this.props.cardId) {
          return this.props.cardId;
        }
        if ((_DeckUI$currentCard = _state.DeckUI.currentCard) !== null && _DeckUI$currentCard !== void 0 && _DeckUI$currentCard.id) {
          return _state.DeckUI.currentCard.id;
        }
      }
    }, {
      key: "card",
      get: function get() {
        var _AppUI$cardStore$show2,
          _this2 = this;
        if (this.props.card) {
          return this.props.card;
        }
        if (this.cardId && cardIdsMatch((_AppUI$cardStore$show2 = _state.AppUI.cardStore.showData) === null || _AppUI$cardStore$show2 === void 0 ? void 0 : _AppUI$cardStore$show2.id, this.cardId)) {
          return _state.AppUI.cardStore.showData;
        }
        if (this.cardId) {
          var _AppUI$cardStore$inde;
          var indexCard = (_AppUI$cardStore$inde = _state.AppUI.cardStore.indexData) === null || _AppUI$cardStore$inde === void 0 ? void 0 : _AppUI$cardStore$inde.find(function (item) {
            return cardIdsMatch(item.id, _this2.cardId);
          });
          if (indexCard) {
            return indexCard;
          }
        }
        if (_state.DeckUI.layout.isNative) {
          return _state.DeckUI.currentCard;
        }
        return {};
      }
    }, {
      key: "wordId",
      get: function get() {
        var _this$card3;
        return (_this$card3 = this.card) === null || _this$card3 === void 0 || (_this$card3 = _this$card3.word) === null || _this$card3 === void 0 ? void 0 : _this$card3.id;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          card: this.card,
          frontText: this.frontText(),
          savingNote: this.savingNote,
          showEdit: this.showEdit,
          wordId: this.wordId,
          onSetShowEdit: this.onSetShowEdit,
          onSubmitNote: this.onSubmitNote,
          onChangeShowNoteBeforeReveal: this.onChangeShowNoteBeforeReveal
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "showEdit", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "savingNote", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "cardId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "card", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "card"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "wordId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wordId"), _class2.prototype), _class2)) || _class;
};
CardNoteWrapper.displayName = 'CardNoteWrapper';
var _default = exports["default"] = CardNoteWrapper;